import { useRef } from 'react';
import { ShowIf, ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    useExperienceDateSold,
    useExperienceProjectTypeId,
    useExperienceSalesPrice,
    useExperienceStillOwn,
} from '../../../../fields/ExperienceFields';
import { ExperienceProjectType } from '@apply/constants';

interface CurrentlyOwnPropertyProps {
    experienceId: string | undefined;
    required?: boolean;
}

export const CurrentlyOwnProperty: React.FC<CurrentlyOwnPropertyProps> = ({ experienceId, required = false }) => {
    const isFirstLoad = useRef(true);
    const label = 'Do you still currently own the property?';
    const [projectType] = useExperienceProjectTypeId(experienceId);
    const [currentlyOwnProperty, set_currentlyOwnProperty] = useExperienceStillOwn(experienceId);
    const [, set_dateSold] = useExperienceDateSold(experienceId);
    const [, set_salesPrice] = useExperienceSalesPrice(experienceId);

    const showRentalWarning = projectType === ExperienceProjectType.Construction && currentlyOwnProperty;

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        // Skip the first change triggered by initial load
        if (isFirstLoad.current) {
            isFirstLoad.current = false;

            // Only skip if editing an existing experience
            if (currentlyOwnProperty !== undefined && currentlyOwnProperty !== null) {
                return;
            }
        }

        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_currentlyOwnProperty(true);
                set_dateSold(undefined);
                set_salesPrice(undefined);
                return;
            case 'no':
                set_currentlyOwnProperty(false);
                return;
            default:
                return;
        }
    };

    const rentalWarning = (
        <div style={{ color: '#db0007', paddingTop: '1rem', paddingBottom: '1rem' }}>
            <FontAwesomeIcon
                icon={faWarning}
                style={{ paddingRight: '1rem' }}
            />
            Please ensure this shouldn't be a Rental Property
        </div>
    );

    return (
        <>
            <YesNoToggleButton
                id='toggleButtonCurrentlyOwnProperty'
                value={currentlyOwnProperty}
                onItemClick={toggleButtonYesNoClick}
                width='230px'
                height='40px'
                required={required}
                requiredMessage='This field is required.'
                label={label}
                labelSize={ToggleButtonLabelSize.SmallBold}
            />
            <ShowIf showIf={showRentalWarning}>{rentalWarning}</ShowIf>
        </>
    );
};
